import { create } from "zustand"

const useUserStore = create((set) => ({
	userCredits: null,
	userEmail: null,
	userPlan: null,

	setUserCredits: (credits) => set({ userCredits: parseInt(credits) }),
	setUserEmail: (email) => set({ userEmail: email }),
	setUserPlan: (plan) => set({ userPlan: plan }),
	setUser: (user) =>
		set({
			userCredits: parseInt(user.credits),
			userEmail: user.email || "",
			userPlan: user.plan || ""
		})
}))

export default useUserStore
